export default __webpack_public_path__ + "static/media/contactBgDec1.ad79e968.png";